import { Link } from 'react-router-dom';
import { Button, Card, Notice } from '@kollez/design-system';

/**
 * /workflows/run — Deep-audit rewrite (Page 55/N).
 *
 * The previous version of this page was a direct port of the static
 * Kollez workflow-run mockup: 412 hardcoded applicants across 5 fake
 * stage counts, 8 named candidates ('Arjun Naidu', 'Meghana Varma',
 * 'Rahul Teja', 'Sowmya K.', 'Kiran Kumar B.', 'Bhavana L.',
 * 'Pranav Reddy', 'Divya Sri'), fabricated panel members ('Rakesh S.'),
 * invented dates ('Interview on 25 Sept, 11:30' / '26 Sept'), and a
 * fairness sidebar with hardcoded slice counts across CSE/ECE/IT/EEE
 * plus 'GIT campus / GEC campus'. Every user of every tenant saw the
 * same made-up workflow-run about the same made-up candidates — a
 * straight fabrication under feedback_fabricated_aggregates.
 *
 * Real per-workflow-run data lives in the WorkflowRun collection and
 * the per-application progress pages. This standalone /workflows/run
 * route with no :id param has no data source; a workflow run is
 * always keyed to an application or a drive.
 *
 * Rather than delete the route (there may be old bookmarks pointing
 * here), we render an honest signpost that routes the user to the
 * places where real workflow-run data exists.
 */
export function WorkflowRunPage() {
  return (
    <div className="stack">
      <div className="page-header">
        <div className="ph-text">
          <p className="eyebrow">Process</p>
          <h1 className="h-page">Open a specific workflow run</h1>
          <p className="subhead">
            Workflow-run data is per-application or per-drive. Pick a drive or an application
            below to see how far it's progressed through the workflow.
          </p>
        </div>
      </div>

      <Card padding="lg">
        <Notice tone="info">
          There's no combined workflow-run view — every run belongs to a specific application on
          a specific drive. Head to Drives or Applications to open one.
        </Notice>
        <div className="flex gap-2 flex-wrap mt-4">
          <Link to="/tpo/drives">
            <Button variant="primary">Open my drives</Button>
          </Link>
          <Link to="/applications">
            <Button variant="secondary">Open my applications</Button>
          </Link>
          <Link to="/workflows">
            <Button variant="ghost">Workflow templates</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
